import Navbar from "../components/LandingPage/Navbar";
import Footer from "../components/LandingPage/Footer";
import PolicyContentRenderer from "../components/LandingPage/PolicyContentRenderer";
import TadarabLogo from "../components/icons/TadarabLogo";
import { termsAndConditions } from "../constants/termsData";
import { useEffect } from "react";

export default function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="policy-page">
      <Navbar />

      <div
        className="policy-page__hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/terms-conditions-hero-image.png)`,
        }}
      >
        <div className="policy-page__hero-inner">
          <span className="policy-page__hero-logo">
            <TadarabLogo />
          </span>
          <p className="policy-page__hero-title">الشروط والأحكام</p>
        </div>
      </div>

      {/* Body */}
      <div className="policy-page__body">
        <p className="policy-page__date">آخر تحديث: ١ يناير ٢٠٢٥</p>
        <PolicyContentRenderer content={termsAndConditions} />
      </div>

      <Footer />
    </div>
  );
}
